export default {
      id: "ic_cross-usage",
      viewBox: "0 0 12 12",
      url: "../dist/images/" + "sprite.svg#ic_cross-usage",
      toString: function () {
        return this.url;
      }
    }